<template>
  <!-- 招标管理  招标详情 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 招标管理  招标详情-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBackTable">店铺管理</span>
        <i class="el-icon-arrow-right"></i
        ><span class="firm-clickable" @click="handelBackTable">订单管理</span
        ><i class="el-icon-arrow-right"></i>
        <span class="firm-clickable" @click="handelBackTable">{{
          tender == "1" ? "招标管理" : "投标管理"
        }}</span>
        <i class="el-icon-arrow-right"></i
        ><span class="firm-clickable" @click="handelBack">{{
          tender == "1" ? "招标详情" : "投标详情"
        }}</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">项目报价及解决方案</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 招标详情-->
        <div class="top-title">
          <div class="Download">
            <p></p>
            下载
          </div>
          <p class="title">项目报价及解决方案</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>
        <!-- 信息卡片 -->
        <div class="card">
          <div class="card-msg">
            <img src="../../../../../assets/imgs/tx1@3x.svg" alt="" />
            <p class="p">张xx</p>
            <p class="p">河南 南阳</p>
            <p class="tag-p">企业</p>
            <p class="star" v-for="(item, index) in mark" :key="index + 1"></p>
            <p
              class="null"
              v-for="(item, index) in 5 - mark"
              :key="index + 10"
            ></p>
            <p class="SalesVolume">销量：2341</p>
          </div>
          <div class="card-msg service-type">
            服务类型：后端开发、LOGO设计、小程序、web网站、户外广告设计、xxxx设计、xxx设计。
          </div>
        </div>
        <!-- 内容 -->
        <div class="contentBody">
          <div class="lineBody">
            <p class="title">最终价格（人民币）：</p>
            <div class="content">4000元</div>
          </div>
          <div class="lineBody">
            <p class="title">最终交付时间：</p>
            <div class="content">2024年12月12日</div>
          </div>
          <div class="lineBody">
            <p class="title">交付方式：</p>
            <div class="content">分为两期进行交付</div>
          </div>
        </div>
        <div class="contentBody" style="background: #fbfbfb">
          <div class="lineBody">
            <p class="title">一期交付：</p>
            <div class="content">交付35% 1500元</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              原型图：30张，xx功能，xx功能，xx功能等三大模块一共30张原型图。
            </div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              PRD文档：1份，xx功能，xx功能，xx功能等三大模块的所有内容。
            </div>
          </div>
        </div>
        <div class="contentBody">
          <div class="lineBody">
            <p class="title">二期交付：</p>
            <div class="content">交付65% 2500元</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              UI 图：50张，xx功能，xx功能，xx功能等三大模块中所对应的功能页面。
            </div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">
              系统网站：1份，将UI图以及原型设计的功能全部做进网站中。
            </div>
          </div>
        </div>
        <div class="contentBody" style="background: #fbfbfb">
          <div class="lineBody">
            <p class="title">服务人员：</p>
            <div class="content">产品经理：1名</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">UI设计：1名</div>
          </div>
          <div class="lineBody">
            <p class="title"></p>
            <div class="content">前端开发：1名</div>
          </div>
          <div :class="WinTheBid ? '' : 'notSignet'" class="signet"></div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tender: "", //接收上一个页面跳转时传的key 1是招标详情  2是投标详情  （该页面为招标管理和投标管理的公用页面，用此数据来做区分）
      mark: 4,
      WinTheBid: true, //是否中标
    };
  },
  watch: {},
  components: {},
  created() {
    if (this.$route.query.key != "" && this.$route.query.key != undefined) {
      this.tender = this.$route.query.key;
    }
  },
  destroyed() {},
  methods: {
    // 确定
    handelNext() {},
    // 返回到列表
    handelBackTable() {
      if (this.tender == "1") {
        // 返回招标列表
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 3 },
        });
      } else {
        //返回投标列表
        this.$router.push({
          path: "/HelpShop/ShopOrderSingle",
          query: { key: 4 },
        });
      }
    },
    // 返回
    handelBack() {
      this.$router.push({
        path: "/HelpShop/Tender",
        // key传1 招标详情   传2投标详情
        query: { key: this.tender },
      });
    },
  },
};
</script>

<style scoped lang="less">
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: PingFangSC-Medium;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    .Download {
      display: flex;
      position: absolute;
      top: 10px;
      font-size: 12px;
      color: #333333;
      line-height: 20px;
      p {
        width: 20px;
        height: 20px;
        background-image: url("../../../../../assets/imgs/xiazai@3x.svg");
        background-size: 100% 100%;
        margin-right: 10px;
      }
    }
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  // 卡片
  .card {
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;
    margin-top: 30px;
    padding: 10px;
    margin-bottom: 30px;
    .card-msg {
      width: 100%;
      height: 30px;
      line-height: 30px;
      margin-bottom: 10px;
      font-size: 12px;
      color: #333333;
      display: flex;
      position: relative;
      .SalesVolume {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        font-size: 12px;
        color: #999999;
      }
      img {
        width: 30px;
        height: 30px;
        margin: auto 0;
      }
      .p {
        font-size: 12px;
        color: #333333;
        margin: 0px 10px 0px 10px;
      }
      .tag-p {
        width: 60px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        margin: auto 0;
        font-size: 10px;
        color: #409eff ;
        background: rgba(97, 144, 232, 0.2);
        border-radius: 5px;
        margin: 5px 10px 5px 10px;
      }
      .star {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
      .null {
        width: 15px;
        height: 14px;
        background-image: url("../../../../../assets/imgs/shoucang-null@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-right: 2px;
      }
    }
    .service-type {
      text-indent: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  // 内容主体
  .contentBody {
    width: 100%;
    min-height: 30px;
    padding: 10px 0px 10px 0px;
    background: #eeeeee;
    position: relative;
    .lineBody:nth-child(1) {
      margin-top: 0px;
    }
    .lineBody {
      width: 95%;
      min-height: 30px;
      line-height: 30px;
      margin-top: 10px;
      display: flex;
      font-family: PingFangSC-Medium;
      font-weight: 400;
      .title {
        width: 260px;
        font-size: 14px;
        color: #666666;
        text-align: right;
      }
      .content {
        flex: 1;
        font-size: 12px;
        color: #333333;
        display: flex;
      }
    }
    // 中标未中标印章
    .signet {
      width: 100px;
      height: 100px;
      position: absolute;
      top: 50px;
      right: 100px;
      background-image: url("../../../../../assets/imgs/zhongbiao@3x.svg");
      background-size: 100% 100%;
    }
    .notSignet {
      background-image: url("../../../../../assets/imgs/weizhongbiao-xiao@3x.svg");
      background-size: 100% 100%;
    }
  }
}
</style>
